module.exports = __webpack_public_path__ + "img/20171229_171932.91d05536.jpg";